import { render, staticRenderFns } from "./DetalheOfertaView.vue?vue&type=template&id=f4699ef2"
import script from "./DetalheOfertaView.vue?vue&type=script&lang=js"
export * from "./DetalheOfertaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4699ef2')) {
      api.createRecord('f4699ef2', component.options)
    } else {
      api.reload('f4699ef2', component.options)
    }
    module.hot.accept("./DetalheOfertaView.vue?vue&type=template&id=f4699ef2", function () {
      api.rerender('f4699ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DetalheOfertaView.vue"
export default component.exports